import { Page } from 'layouts/Page';
import { FC } from 'react';
import { UploadedSalesReports } from 'components/UploadedSalesReports';

export const UploadedSalesReportsPage: FC = () => {
	return (
		<Page title="Integrations – EAS Dashboard">
			<UploadedSalesReports />
		</Page>
	);
};
